import { render, staticRenderFns } from "./salesOneList.vue?vue&type=template&id=676155da&scoped=true"
import script from "./salesOneList.vue?vue&type=script&lang=js"
export * from "./salesOneList.vue?vue&type=script&lang=js"
import style0 from "./salesOneList.vue?vue&type=style&index=0&id=676155da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676155da",
  null
  
)

export default component.exports